import { render } from "./QuickInformationCards.vue?vue&type=template&id=515c5882&scoped=true"
import script from "./QuickInformationCards.vue?vue&type=script&lang=js"
export * from "./QuickInformationCards.vue?vue&type=script&lang=js"

import "./QuickInformationCards.vue?vue&type=style&index=0&id=515c5882&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515c5882"]])

export default __exports__